<!-- @veltra/icons generated sha256:589ff1e004381259 gen:8 source:src/svg/normal/star-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'StarFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m8.396 1.8 1.81 3.666 4.044.588c.37.054.511.491.244.752l-2.926 2.853.69 4.028a.437.437 0 0 1-.64.465L8.002 12.25l-3.618 1.902a.437.437 0 0 1-.64-.465l.692-4.028-2.927-2.853a.437.437 0 0 1 .244-.752l4.045-.588 1.809-3.665a.437.437 0 0 1 .79 0"
    />
  </svg>
</template>
